// Pineapple - UI 환경설정 (Checklist §13-A)
const LS_KEY = 'pineapple.sidebarCollapsed';

const state = {
  sidebarCollapsed: localStorage.getItem(LS_KEY) === 'true',
};

const getters = {
  isSidebarCollapsed: (s) => s.sidebarCollapsed,
};

const mutations = {
  TOGGLE_SIDEBAR(s) {
    s.sidebarCollapsed = !s.sidebarCollapsed;
    localStorage.setItem(LS_KEY, String(s.sidebarCollapsed));
  },
  SET_SIDEBAR_COLLAPSED(s, value) {
    s.sidebarCollapsed = !!value;
    localStorage.setItem(LS_KEY, String(s.sidebarCollapsed));
  },
};

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR');
  },
  setSidebarCollapsed({ commit }, value) {
    commit('SET_SIDEBAR_COLLAPSED', value);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

